"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLAY_ICON = exports.DEFAULT_PLAY_SIZE = exports.DEFAULT_CIRCLE_SIZE = void 0;
const PLAY_ICON = exports.PLAY_ICON = 'play-icon';
const DEFAULT_CIRCLE_SIZE = exports.DEFAULT_CIRCLE_SIZE = 48;
const DEFAULT_PLAY_SIZE = exports.DEFAULT_PLAY_SIZE = 24;
//# sourceMappingURL=constants.js.map